import CreateHeader from '@components/layout/createHeader/CreateHeader';
import { RootState } from '@reducers/index';
import { getChallengeGroup } from '@selectors/challengeGroups';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import Description from 'lib/src/components/typography/Description';
import Title from 'lib/src/components/typography/Title';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { challengeGroupsChallengesBreadcrumb } from '../../../../src/constants/breadcrumbItems';
import EditChallengeGroupScoreWeightingModal from '../EditChallengeGroupScoreWeightingModal';
import EditChallengeHolderModal from '../EditChallengeHolderModal';
import ChallengeGroupChallengesTable from './ChallengeGroupChallengesTable';
import DeleteChallengeModal from './DeleteChallengeModal';
import useFetchChallengeGroupChallenges from './hooks/useFetchChallengeGroupChallenges';
import useHasChallengeCrudPermissions from '../../../utils/hooks/useHasChallengeCrudPermissions';

const ChallengeGroupChallenges = () => {
    const { id, action } = useParams<Params>();
    const [showEditScoreWeightingModal, setShowEditScoreWeightingModal] = useState<boolean>(false);
    const [showEditChallengeHolderModal, setShowEditChallengeHolderModal] = useState<boolean>(
        false,
    );

    useFetchChallengeGroupChallenges(+id);
    const group = useSelector((state: RootState) => getChallengeGroup(state, +id));

    const challengeGroup = useSelector((state: RootState) => getChallengeGroup(state, +id));

    const hasChallengeCrudPermissions = useHasChallengeCrudPermissions(challengeGroup);

    return (
        <>
            <Breadcrumb items={challengeGroupsChallengesBreadcrumb} title={group.name || '-'} />
            <CreateHeader>
                <Title>Challenges</Title>
                {hasChallengeCrudPermissions && (
                    <LinkButton
                        color="green"
                        icon="plus"
                        href={`/challenge-groups/${id}/challenges/create`}
                    >
                        Create Challenge
                    </LinkButton>
                )}
            </CreateHeader>
            {hasChallengeCrudPermissions && (
                <ButtonRow alignment="left">
                    <ActionButton
                        icon="star"
                        color="blue"
                        onClick={() => setShowEditScoreWeightingModal(true)}
                    >
                        Edit Default Score Weightings
                    </ActionButton>
                    <ActionButton
                        icon="user-tie"
                        color="darkblue"
                        onClick={() => setShowEditChallengeHolderModal(true)}
                    >
                        Update Challenge Holder
                    </ActionButton>
                </ButtonRow>
            )}
            <Description>
                Here is the list of the challenges in the challenge group '{group.name}'.
            </Description>
            <ChallengeGroupChallengesTable group={group} />
            {action === 'delete' && <DeleteChallengeModal />}
            {showEditScoreWeightingModal && (
                <EditChallengeGroupScoreWeightingModal
                    challengeGroup={group}
                    setShowEditScoreWeightingModal={setShowEditScoreWeightingModal}
                />
            )}
            {showEditChallengeHolderModal && (
                <EditChallengeHolderModal
                    challengeGroup={group}
                    setShowEditChallengeHolderModal={setShowEditChallengeHolderModal}
                />
            )}
        </>
    );
};

interface Params {
    id: string;
    action: string;
}

export default ChallengeGroupChallenges;
